import CollectionDetailPage from './CollectionDetailPage.container'

export default CollectionDetailPage
